import React, { useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const handleLogin = async () => {
    setError("");
    try {
      const response = await fetch("https://app.mirzawaleed.com/login.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      const result = await response.json();
      if (response.ok) {
        navigate('/index');
      } else {
        setError(result.message || "Login failed. Please try again.");
      }
    } catch (error) {
      console.error("Error during login:", error);
      setError("Login failed. Please check your network and try again.");
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.loginBox}>
        <h2 style={styles.heading}>Login to HBD</h2>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          style={styles.inputField}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={styles.inputField}
        />
        {error && <p style={styles.errorText}>{error}</p>}
        <button onClick={handleLogin} style={styles.loginButton}>
          Login
        </button>
        <div style={styles.privacyLinks}>
          <a href="/privacy-policy" style={styles.link}>
            Privacy Policy
          </a>
          <a href="/terms-of-service" style={styles.link}>
            Terms of Service
          </a>
        </div>
      </div>
      <p style={{position:"fixed",bottom:'20px', width:'100%',fontSize:'12px',color:'black',textAlign:'center'}}>Developed By <a href="https://mirzawaleed.com/" target="_blank">Mirza Waleed</a></p>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f0f0f0",
  },
  loginBox: {
    padding: "40px",
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
    flexDirection:"column",
    borderRadius: "10px",
    width: "100%",
    maxWidth: "400px",
  },
  heading: {
    fontSize: "24px",
    marginBottom: "20px",
    textAlign: "start",
    color: "#333",
  },
  inputField: {
    width: "300px",
    padding: "10px",
    marginBottom: "15px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    fontSize: "16px",
    maxWidth:"300px",
  },
  loginButton: {
    width: "320px",
    padding: "10px",
    backgroundColor: "#007BFF",
    color: "#fff",
    borderRadius: "5px",
    border: "none",
    fontSize: "16px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  },
  loginButtonHover: {
    backgroundColor: "#0056b3",
  },
  privacyLinks: {
    marginTop: "20px",
    textAlign: "center",
  },
  link: {
    color: "#007BFF",
    textDecoration: "none",
    margin: "0 10px",
    fontSize: "14px",
  },
  errorText: {
    color: "red",
    marginBottom: "15px",
    textAlign: "center",
  },
};

export default LoginPage;
